module.exports = __webpack_public_path__ + "img/analitycs-card.051f4105.svg";